import type { InviteStatus } from '@lib/enums/invite-status.enum'
import { StatusPill, type PillTone } from '@/components/StatusPill'

/**
 * Status pill for an invite.
 *
 * The hue mapping is semantic, not decorative: green reads as done, gray as
 * inert, amber as needing attention. The shape is the shared status pill, so
 * an invite stays on one line the way every other status does.
 */
const STATUS_TONES: Record<InviteStatus, PillTone> = {
  PENDING: 'blue',
  ACCEPTED: 'green',
  EXPIRED: 'yellow',
  REVOKED: 'gray',
}

const STATUS_LABELS: Record<InviteStatus, string> = {
  PENDING: 'Pending',
  ACCEPTED: 'Accepted',
  EXPIRED: 'Expired',
  REVOKED: 'Revoked',
}

interface InviteStatusBadgeProps {
  status: InviteStatus
  className?: string
}

export function InviteStatusBadge({
  status,
  className,
}: InviteStatusBadgeProps) {
  return (
    <StatusPill
      tone={STATUS_TONES[status]}
      {...(className === undefined ? {} : { className })}
    >
      {STATUS_LABELS[status]}
    </StatusPill>
  )
}
